import React from 'react';
import InputField from 'Components/Input/InputField';
import Button from 'Components/Button/Button';
import Panel from 'Components/Panel/Panel';

function FilterItems({
    isActiveFilter,
    onUpdatesIsActiveFilter
}) {

    function isActiveFilterSetter() {
        return onUpdatesIsActiveFilter(isActiveFilter === 'S' ? 'N' : 'S')
    }

    const filterUsersPanel = {
        width: '100%',
        height: '17%',
        display: 'flex',
        flexDirection: 'column'
    };

    return (
        <>
            <Panel style={filterUsersPanel}
                titlePage={'Filtros'}
                canViewCRUD={true}
            >
                <Panel>
                    <div style={{display: 'flex', flexDirection: 'column', marginLeft: '30px'}}>
                        <span className='span-sector-filter'>Ativo</span>
                        <InputField
                            setAttribute={(event) => isActiveFilterSetter(event)}
                            value={isActiveFilter}
                            checked={isActiveFilter === 'S'}
                            readOnly={false}
                            disabled={false}
                            type="checkbox"
                            style={{ cursor: 'pointer' }}
                        />
                    </div>
                </Panel>
            </Panel>
        </>
    );
};

export default FilterItems;